import objectToQueryString from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPmcTracking: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (searchParams.pmcId !== undefined) {
			queryStr = objectToQueryString({
				pmcId: searchParams.pmcId,
				carVin: searchParams.carVin,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/mqy/qlty/pmcTracking/v1/pmcId` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
